import { FormValidator, type FormValidatorConfig, type FormValidatorSettings, isEmpty } from '@common';
import { formatDate } from '@vueuse/core';

export interface FertilizationPlanDateValidatorSettings extends FormValidatorSettings {
  minDate: Date;
  maxDate: Date;
  allowEqual: boolean;
  invalidMessageMin: string;
  invalidMessageMax: string;
}

export type FertilizationPlanDateValidatorConfig = FormValidatorConfig<FertilizationPlanDateValidatorSettings>;

export class FertilizationPlanDateValidator extends FormValidator<FertilizationPlanDateValidatorSettings> {
  constructor() {
    super();
    this._name = 'fertilizationPlanDate';
    this._settings = {
      invalidMessage: 'form.validator.fertilizationPlanDate.invalidMessage',
      invalidMessageMin: 'form.validator.fertilizationPlanDate.invalidMessageMin',
      invalidMessageMax: 'form.validator.fertilizationPlanDate.invalidMessageMax',
      needTranslate: true,
      minDate: new Date(),
      maxDate: new Date(),
      allowEqual: true
    };
  }

  public override async onValidate(value: any) {
    if (isEmpty(value)) {
      this.reset();
      return;
    }

    const dateValue = new Date(value);
    dateValue.setHours(0, 0, 0, 0);

    const minDate = new Date(this.settings.minDate);
    minDate.setHours(0, 0, 0, 0);

    const maxDate = new Date(this.settings.maxDate);
    maxDate.setHours(0, 0, 0, 0);

    const minValid = this.settings.allowEqual ? dateValue >= minDate : dateValue > minDate;
    const maxValid = this.settings.allowEqual ? dateValue <= maxDate : dateValue < maxDate;

    this._valid = minValid && maxValid;

    if (!this._valid) {
      if (!minValid && !maxValid) {
        this.addMessage(this.settings.invalidMessage, 'error', {
          minDate: formatDate(this.settings.minDate, 'YYYY.MM.DD.'),
          maxDate: formatDate(this.settings.maxDate, 'YYYY.MM.DD.')
        });
      } else if (!minValid) {
        this.addMessage(this.settings.invalidMessageMin, 'error', {
          minDate: formatDate(this.settings.minDate, 'YYYY.MM.DD.')
        });
      } else {
        this.addMessage(this.settings.invalidMessageMax, 'error', {
          maxDate: formatDate(this.settings.maxDate, 'YYYY.MM.DD.')
        });
      }
    }
  }
}
